import React from "react";
import { OrdersErrors, OrderTypes } from "@shared/features/trades/common/types";
import {
  FixMeLater,
  GetTradeExtraInfoOrdersResponse,
  LineAnnotation,
  PointAnnotation,
  PrecisionConfig,
} from "@shared/types";
import {
  AddOrder,
  CancelOrder,
  EditOrderData,
  MoveOrderToCurrentPrice,
  MoveStopOrderToBreakevenPrice,
  TradeAmountData,
  UpdateOrder,
} from "@shared/features/trades/EditTrade/types";

const EditTradeContext = React.createContext<
  | {
      amountsDataLoading: boolean;
      amountData: TradeAmountData;
      quantityData: TradeAmountData;
      entryOrders: EditOrderData[];
      activeEntryOrders?: EditOrderData[];
      takeProfitOrders: EditOrderData[];
      stopOrders: EditOrderData[];
      addAmountModalOpen: boolean;
      setAddAmountModalOpen: (isOpen: boolean) => void;
      addQuantityModalOpen: boolean;
      setAddQuantityModalOpen: (isOpen: boolean) => void;
      updateOrder: UpdateOrder;
      setEntryOrders: (order: EditOrderData[]) => void;
      setTakeProfitOrders: (order: EditOrderData[]) => void;
      setStopOrders: (order: EditOrderData[]) => void;
      precisionConfig?: PrecisionConfig;
      getOrdersByType: (orderType: OrderTypes) => EditOrderData[];
      setOrdersByType: (orderType: OrderTypes, orders: EditOrderData[]) => void;
      cancelOrder: CancelOrder;
      addOrder: AddOrder;
      moveOrderToCurrentPrice: MoveOrderToCurrentPrice;
      moveStopOrderToBreakevenPrice: MoveStopOrderToBreakevenPrice;
      breakevenPrice: number;
      confirmWithCallback: (message: string) => Promise<boolean>;
      currentPrice: number;
      ordersData?: GetTradeExtraInfoOrdersResponse;
      onSaveChangesClick: () => void;
      onCancelChangesClick: (onCancelChangesCallback?: () => void) => void;
      valuesModified: boolean;
      onValuesModified: () => void;
      updateOrdersWithAddedAmount: (addedAmount: number) => void;
      updateOrdersWithAddedQuantity: (addedQuantity: number) => void;
      editTradeLoading: boolean;
      editTradeConfigurationLoading: boolean;
      ordersErrors: OrdersErrors;
      generalConfiguration: FixMeLater;
      convertAmountToQuantity: (amount: number, quantity: number) => number;
      getMinAmountByPrice: (price: number) => number;
      weightedAverageEntryPrice: number;
      isBotTrade: boolean;
      isEdit: boolean;
      functionsRef: React.RefObject<{
        onConfirm: () => void;
        onCancel: (callback?: () => void) => void;
      }>;
      editTradeAnnotations: (LineAnnotation | PointAnnotation)[];
    }
  | undefined
>(undefined);

export default EditTradeContext;
